export default "__VITE_ASSET__Tcdh7bx9__"